import React from 'react';
import { Clock, Shield, Activity, Users } from 'lucide-react';
const bonuses = [{
  title: 'Clinical Quick Reference Guide™',
  description: 'Instant access to clinical references, assessment reminders, rehabilitation frameworks, and treatment planning tools for faster decision-making.'
}, {
  title: 'Home Exercise Builder™',
  description: 'Create personalized home exercise programs in minutes using editable templates, planners, and patient instruction resources.'
}, {
  title: 'Patient Progress Dashboard™',
  description: 'Track patient improvements with professional goal trackers, recovery timelines, reassessment forms, and progress monitoring tools.'
}, {
  title: 'Clinic Productivity Planner™',
  description: 'Organize your schedule, patient caseload, appointments, and daily workflow with practical clinic management templates.'
}, {
  title: 'Clinical Communication Toolkit™',
  description: 'Improve patient communication with ready-to-use consultation guides, educational resources, follow-up templates, and engagement tools.'
}];
const benefits = [{
  icon: <Clock className="w-6 h-6 text-brand-navy" data-id="element-15" />,
  title: 'Save Hours Every Week',
  desc: 'Stop creating treatment plans, documentation, and patient resources from scratch. Open the system, choose the right framework, and start treating your patients with confidence.'
}, {
  icon: <Shield className="w-6 h-6 text-brand-navy" data-id="element-16" />,
  title: 'Greater Clinical Confidence',
  desc: 'Know exactly how to assess patients, organize rehabilitation plans, document progress, and structure treatments with a complete clinical system behind every decision.'
}, {
  icon: <Activity className="w-6 h-6 text-brand-navy" data-id="element-17" />,
  title: 'Better Patient Outcomes',
  desc: 'Deliver structured rehabilitation programs that improve mobility, function, recovery, and long-term patient progress through clear and organized treatment pathways.'
}, {
  icon: <Users className="w-6 h-6 text-brand-navy" data-id="element-18" />,
  title: 'Improve Patient Retention',
  desc: 'Keep your patients engaged and motivated with professional treatment plans, measurable progress, and a more organized rehabilitation experience that encourages long-term commitment.'
}];
export function BonusSection() {
  return <>
      <section className="py-14 px-4 sm:px-6 bg-brand-paper" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-4 uppercase leading-tight" data-id="element-21">
            5 PREMIUM BONUSES INCLUDED
          </h2>
          <p className="text-sm sm:text-base font-bold text-brand-navy leading-relaxed max-w-2xl mx-auto" data-id="element-22">
            You'll also receive 5 premium bonuses designed to help you save even
            more time and improve your daily clinical workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10 max-w-4xl mx-auto" data-id="element-23">
          {bonuses.map((bonus, i) => <div key={i} className={`bg-white border-2 border-brand-gold/40 p-6 rounded-xl text-center shadow-sm relative overflow-hidden hover:border-brand-gold transition-colors ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:max-w-md sm:mx-auto' : ''}`} data-id="element-24">
              <div className="absolute top-0 left-0 w-full h-1.5 bg-brand-gold" data-id="element-25" />
              <p className="text-[11px] font-black text-brand-gold mb-3 tracking-widest uppercase" data-id="element-26">
                🎁 BONUS {i + 1}
              </p>
              <h3 className="text-base font-bold text-brand-navy mb-2 leading-tight uppercase" data-id="element-27">
                {bonus.title}
              </h3>
              <p className="text-sm text-brand-ink/70 leading-relaxed" data-id="element-28">
                {bonus.description}
              </p>
            </div>)}
        </div>
      </section>

      <section className="py-14 px-4 sm:px-6 bg-white border-y border-gray-200" data-id="element-29">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-center text-brand-navy mb-12 uppercase leading-tight" data-id="element-30">
          WHAT WILL CHANGE
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-31">
          {benefits.map((item, i) => <div key={i} className="bg-brand-paper p-6 rounded-xl shadow-sm flex gap-5 items-start border border-gray-100" data-id="element-32">
              <div className="bg-white p-3 rounded-lg shadow-sm shrink-0" data-id="element-33">
                {item.icon}
              </div>
              <div data-id="element-34">
                <h3 className="text-base font-bold text-brand-navy mb-2 uppercase tracking-tight" data-id="element-35">
                  {item.title}
                </h3>
                <p className="text-brand-ink/70 text-sm leading-relaxed" data-id="element-36">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </section>
    </>;
}